// extracted by css-extract-rspack-plugin
export default {"dialog":"E35P5n4aHlMGjxqA","pleaseEnable":"cQzQuQ7oWvYI87qE"};